<p-card class="p-card container" [class.proposal-section--valid]="isCompleted && form.valid">
  <h3 class="margin--top-none" i18n>Divulgations</h3>

  <p i18n> Je, {{ primaryAgentFullName }}, </p>

  <ul>
    <li i18n>Certifie avoir confirmé l’identité de {{ clientFullName }}</li>
    <ul>
      <li i18n>Type de document : {{ translate.getTranslation(idDocument.type) }}</li>
      <li>{{ idDocument.code }}</li>
    </ul>
    <li i18n>Reconnais avoir procédé à l’analyse des besoins financiers du client.</li>
    <li i18n>
      Reconnais avoir expliqué les caractéristiques du produit ainsi que les exclusions, limitations et
      restrictions.
    </li>
    <li i18n>Reconnais avoir informé mon client de son droit d’examen de 10 jours.</li>
    <li i18n
      >Certifie avoir complété le questionnaire médicale en communication avec l’assuré(e), en personne ou
      encore via appel téléphonique ou via vidéo-conférence.
    </li>
    <li i18n>Déclare avoir un permis valide dans la juridiction où la demande a été signée.</li>
    <li i18n
      >Confirme avoir déclaré au propriétaire de ce contrat le nom des compagnies que je représente, la
      possibilité que je reçoive une rétribution (telle une commission), ainsi qu’une rétribution
      additionnelle (tel un boni) et que je n’ai aucun conflit d’intérêts avec
      <strong>Humania Assurances inc.</strong> ni avec le propriétaire, et ce concernant la transaction
      proposée.<br />
    </li>
    <li class="margin--bottom-smaller" i18n>Confirme connaître {{ clientFullName }} depuis :</li>

    <div class="layout--third-width">
      <p-dropdown
        [styleClass]="
          form.controls.clientAgentAffiliationTime.touched && form.controls.clientAgentAffiliationTime.invalid
            ? 'error--input'
            : ''
        "
        optionLabel="name"
        optionValue="value"
        [formControl]="form.controls.clientAgentAffiliationTime"
        [options]="clientAgentAffiliationTimeOptions | emTranslate"
        i18n-placeholder
        placeholder="Choisir"></p-dropdown>
    </div>
  </ul>

  @if (!isReadonly) {
    <p-toggleButton
      class="divulgationToggle"
      [ngClass]="{'p-disabled': form.controls.clientAgentAffiliationTime.invalid}"
      [formControl]="form.controls.isAccepted"
      onIcon="pi pi-check"
      i18n-onLabel
      onLabel="Confirmé"
      i18n-offLabel
      offLabel="Je confirme"></p-toggleButton>
  }
</p-card>
